import invariant from '../util/invariant';
import configure from '../util/configure';
import { defaultMessages } from './default-messages';

function getMessage(messages: object, path: string[]) {
  let i;
  let node = messages;
  const length = path.length;

  for (i = 0; i < length - 1; i++) {
    node = node[ path[i] ];

    if (typeof node === 'undefined') {
      return undefined;
    }
  }

  return node[ path[i] ];
}

// simple message localizer with no support for custom locales and variables
export function simpleMessageLocalizer() {
  return {
    formatMessage(path: string | string[], variables?: string | string[] | object, locale?: string): string {
      invariant(typeof variables === 'undefined', 'default message localizer doesn\'t support variables');

      if (locale) {
        throw new Error('[adp-react-components] You are attempting to use a widget with a non-default locale.' +
              'However there is no localizer set. Please configure a message localizer.');
      }

      if (typeof path === 'string') {
        path = path.split('/');
      }

      const message = getMessage(defaultMessages, path);

      if (typeof message !== 'string') {
        throw new Error('Message not found: ' + path.join('/'));
      }

      return message;
    }
  };
}

export default function() {
  const localizer = simpleMessageLocalizer();
  configure.setMessageLocalizer(localizer);
  return localizer;
}
